import React, { useMemo } from "react";
import { GlobalHotKeys } from "react-hotkeys";
import { useField, useFormikContext } from "formik";

import { FIELD, STATS, SWITCH_TEAM, SUBMIT_DATA } from "../constants";
import { TEAM_TYPE, IStatsValue } from "../types";
import { statActionKeyMap, operationKeyMap } from "./keymap";

export const HotKeys = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [actionField, actionMeta, { setValue: setActionType }] = useField(FIELD.action);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [methodField, methodMeta, { setValue: setActionMethod }] = useField(FIELD.method);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [teamTypeField, teamTypeMeta, { setValue: setTeamType }] = useField(
    FIELD.teamType
  );
  const { submitForm } = useFormikContext();
  const handlers = useMemo(() => {
    const handleStatChange = (actionType: IStatsValue) => {
      setActionType(actionType);
      setActionMethod(1);
    };
    return STATS.reduce((acc, current) => {
      // @ts-ignore
      acc[current.name] = () => {
        handleStatChange(current.name);
      };
      return acc;
    }, {});
  }, [setActionType, setActionMethod]); // only used for satisfying lint, [] should works fine

  const switchHandler = {
    [SWITCH_TEAM]: () => {
      setTeamType(
        teamTypeField.value === TEAM_TYPE.HOME ? TEAM_TYPE.AWAY : TEAM_TYPE.HOME
      );
    },
    [SUBMIT_DATA]: () => {
      submitForm();
    },
  };

  return (
    <GlobalHotKeys keyMap={statActionKeyMap} handlers={handlers}>
      <GlobalHotKeys
        keyMap={operationKeyMap}
        allowChanges
        handlers={switchHandler}
      />
    </GlobalHotKeys>
  );
};
